import { axiosIns } from "../utils";

export const fetchFormationPros = async () => {
  const response = await axiosIns.get("/formation-pro/");
  return response && response.data ? response.data : response;
};

export const createFormationProApi = async (payload) => {
  const response = await axiosIns.post("/formation-pro/", payload);
  return response && response.data ? response.data : response;
};

export const updateFormationProApi = async (id, payload) => {
  const response = await axiosIns.patch(`/formation-pro/${id}/`, payload);
  return response && response.data ? response.data : response;
};

export const deleteFormationProApi = async (id) => {
  const response = await axiosIns.delete(`/formation-pro/${id}/`);
  return response && response.data ? response.data : response;
};
